/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { NextPage } from 'next';

import useTranslation from 'next-translate/useTranslation';
import { Col, Container } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useGenres } from '../../api';
import { withAuthSync } from '../../utils/auth';

import { Tab, Tabs, TabList, TabPanel } from '../../components/common/Tabs';
import RaffleCarousel from '../../components/Carousel/Raffles';
import RaffleOverview from '../../components/Contest/Overview';
import { TextRegular18, TextBold49 } from '../../VuexyDesign/atoms/Text';
import { desktop, noDesktop } from '../../style/constants';
import Row from '../../VuexyDesign/atoms/Row';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import { Dropdown } from '../../VuexyDesign/atoms/_index';
import { VirpPageContext } from '../_app';

const ConnectOverviewPage: NextPage = () => {
  const defaultIndex = 0;
  const { t } = useTranslation('contests');

  const [totalContests, setTotalContests] = useState<number>(0);

  const [totalRemixContests, setTotalRemixContests] = useState<number>(0);

  const [totalTalentContests, setTotalTalentContests] = useState<number>(0);

  const [totalRaffles, setTotalRaffles] = useState<number>(0);

  const [placeholder, setPlaceholder] = useState<string>();
  useEffect(() => {
    setPlaceholder(t('contests:filter') as string);
  }, []);

  const [
    totalOpenDemoSubmissions,
    setTotalOpenDemoSubmissions,
  ] = useState<number>(0);

  const allGenres = useGenres();
  const [selectedGenres, setSelecterGenres] = useState<Option[]>([]);

  const handleGenreChange = (
    selected: Option | Option[] | undefined | null,
  ) => {
    if (!selected || !Array.isArray(selected)) {
      return;
    }
    setSelecterGenres(selected);
  };

  const selectedCountries: any[] = [];

  return (
    <StyledContainer fluid>
      <Col>
        <BrowserPageTitle>{t('contests:browserpagetitle')}</BrowserPageTitle>
        <TopRafflesTitle as="div">
          <span className="custom-heading-font-1">
            {t('contests:connect.connect1')}
          </span>
        </TopRafflesTitle>
        <TopRafflesSubTitle as="div">
          <span className="custom-font-text-medium-normal">
            {t('contests:connect.connect2')}
          </span>
        </TopRafflesSubTitle>
      </Col>
      <Col noGutter>
        <RaffleCarousel />
      </Col>
      <Col>
        <StyledContainerTabs>
          <Tabs defaultIndex={defaultIndex}>
            <Row className="mb-2 d-flex align-items-baseline mt-1">
              <Col xs={12} md={8} className="d-flex align-items-baseline">
                <TabList>
                  <Tab className="mr-1">
                    {t('contests:overview.tab1') as string}
                    <Count>{totalContests}</Count>
                  </Tab>
                  <Tab className="mr-1">
                    {t('contests:overview.tab2') as string}
                    <Count>{totalRemixContests}</Count>
                  </Tab>
                  <Tab className="mr-1">
                    {t('contests:overview.tab3') as string}
                    <Count>{totalTalentContests}</Count>
                  </Tab>
                  <Tab className="mr-1">
                    {t('contests:overview.tab4') as string}
                    <Count>{totalRaffles}</Count>
                  </Tab>
                  <Tab className="mr-1">
                    {t('contests:overview.tab5') as string}
                    <Count>{totalOpenDemoSubmissions}</Count>
                  </Tab>
                </TabList>
              </Col>
              <Col xs={12} md={4} className="w-100 mt-1">
                <Dropdown
                  placeholder={placeholder}
                  options={allGenres.map((genre) => ({
                    value: genre.id,
                    label: genre.name,
                  }))}
                  onChange={handleGenreChange}
                  isClearable
                  value={selectedGenres}
                  isMulti
                  hideSelectedOptions={false}
                />
                {/* <ConnectDropdown
                  label="Filter by genres"
                  allValues={allGenres.map((genre) => ({
                    value: genre.id,
                    label: genre.name,
                  }))}
                  setSelectedValues={handleGenreChange}
                /> */}
              </Col>
              {/* <Col xs={12} md={4} className="mb-1">
                <ConnectDropdown
                  label="Filter by countries"
                  allValues={allCountries.map((country) => ({
                    value: country.id,
                    label: country.name,
                  }))}
                  setSelectedValues={handleCountryChange}
                />
              </Col> */}
            </Row>
            <TabPanel forceRender className="react-tabs__tab-panel">
              <RaffleOverview
                filter="all"
                updateTotal={setTotalContests}
                genres={selectedGenres.map((item) => `${item.value},`).join('')}
                countries={selectedCountries
                  .map((item) => `${item.value},`)
                  .join('')}
              />
            </TabPanel>
            <TabPanel forceRender className="react-tabs__tab-panel">
              <RaffleOverview
                filter="remix_contests"
                updateTotal={setTotalRemixContests}
                genres={selectedGenres.map((item) => `${item.value},`).join('')}
                countries={selectedCountries
                  .map((item) => `${item.value},`)
                  .join('')}
              />
            </TabPanel>

            <TabPanel forceRender className="react-tabs__tab-panel">
              <RaffleOverview
                filter="talent_contests"
                updateTotal={setTotalTalentContests}
                genres={selectedGenres.map((item) => `${item.value},`).join('')}
                countries={selectedCountries
                  .map((item) => `${item.value},`)
                  .join('')}
              />
            </TabPanel>

            <TabPanel forceRender className="react-tabs__tab-panel">
              <RaffleOverview
                filter="raffles"
                updateTotal={setTotalRaffles}
                genres={selectedGenres.map((item) => `${item.value},`).join('')}
                countries={selectedCountries
                  .map((item) => `${item.value},`)
                  .join('')}
              />
            </TabPanel>
            <TabPanel forceRender className="react-tabs__tab-panel">
              <RaffleOverview
                filter="open_demo_submission"
                updateTotal={setTotalOpenDemoSubmissions}
                genres={selectedGenres.map((item) => `${item.value},`).join('')}
                countries={selectedCountries
                  .map((item) => `${item.value},`)
                  .join('')}
              />
            </TabPanel>
          </Tabs>
        </StyledContainerTabs>
      </Col>
    </StyledContainer>
  );
};

const StyledContainer = styled(Container)`
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
`;

const StyledContainerTabs = styled(Container)`
  max-width: 1360px;
  width: 100%;
  margin: 0 auto;
`;

const TopRafflesTitle = styled(TextBold49)`
  width: 100%;
  text-align: left;
  margin-bottom: 4px;

  @media ${desktop} {
    margin-top: 24px;
  }

  @media ${noDesktop} {
    margin-top: 10px;

    ${TextBold49} {
      display: -webkit-box;
      text-align: left;
      -webkit-line-clamp: 2;
      @media ${noDesktop} {
        -webkit-line-clamp: 4;
        font-size: 28px;
      }
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;

const TopRafflesSubTitle = styled(TextRegular18)`
  width: 100%;
  text-align: left;
  margin-bottom: 24px;

  @media ${desktop} {
    margin-top: 5px;
  }

  @media ${noDesktop} {
    margin-bottom: 10px;
    ${TextRegular18} {
      display: -webkit-box;
      text-align: left;
      -webkit-line-clamp: 2;
      @media ${noDesktop} {
        -webkit-line-clamp: 4;
        font-size: 16px;
      }
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;

const Count = styled.span`
  height: 22px;
  margin-left: 6px;
  display: inline-block;
  padding: 0 2px;
  text-align: center;
  min-width: 22px;
  background-color: #fff;
  border: 1px solid;
  border-radius: 5px;
`;

ConnectOverviewPage.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/connect',
  });
  return { ...getTranslations };
};

export default withAuthSync(ConnectOverviewPage, {
  protected: false,
});

interface Option {
  value: string | number;
  label: string;
}
